const appConfig: AppConfig = window.APP_CONFIG || {};
const cordysConfig = appConfig.cordys || {};
const trianectConfig = appConfig.trianect || {};

export const Configuration = {
  AZNConnectApiUrl: process.env.VUE_APP_AZNCONNECT_API_ROOT || "",
  SignalRUrl: process.env.VUE_APP_SIGNALR_URL || "",
  pastReferralThresholdMinutes:
    appConfig.pastReferralThresholdMinutes != null
      ? appConfig.pastReferralThresholdMinutes
      : -5,
  showArrivalFeatures:
    appConfig.showArrivalFeatures != null
      ? appConfig.showArrivalFeatures
      : false,
  showMessageHistory:
    appConfig.showMessageHistory != null ? appConfig.showMessageHistory : false,
  cordysEcgDemoMode:
    cordysConfig.ecgDemoMode != null ? cordysConfig.ecgDemoMode : false,
  trianectEegDemoMode:
    trianectConfig.eegDemoMode != null ? trianectConfig.eegDemoMode : false,
};
